"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAtLeastOneCloze = void 0;
var ClozeRegex_1 = require("../../constants/ClozeRegex");
function hasAtLeastOneCloze(textFieldValue) {
    var matches = textFieldValue.match(ClozeRegex_1.CLOZE_REGEX.CAPTURE_NUM);
    return matches != null;
}
exports.hasAtLeastOneCloze = hasAtLeastOneCloze;
